export default __webpack_public_path__ + "assets/e9f7b934ef8ad42038c6319dcfed7f92.jpg";